// Set log level if development mode
if (window.Shopify?.theme.role === 'development') {
  log.setLevel(log.levels.TRACE, false);
}

// Log cart value
const cartLogger = () => {
  log.debug('🛍️ Cart', window.liquidAjaxCart.cart);
};

if (window.liquidAjaxCart?.init) {
  cartLogger();
} else {
  document.addEventListener('liquid-ajax-cart:init', cartLogger);
}
